/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CutIcon = ({ width = 24, height = 24, hidden = false, title = 'Cut' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M29.912 22.12c0-.007.035-.028.026-.028a8.481 8.481 0 0 1-7.138-4.018c-.017-.028-.046-.047-.065-.074.019-.027.048-.046.065-.074a8.481 8.481 0 0 1 7.142-4.018c.009 0-.023-.021-.026-.028a5.917 5.917 0 1 0-3.93-1.588l-6.47 3.444-12.6-6.7a4 4 0 0 0-3.8.023L.822 10.313 15.26 18 .822 25.687l2.292 1.255a4 4 0 0 0 3.8.023l12.6-6.7 6.47 3.444a5.892 5.892 0 1 0 3.93-1.588Zm.367-18.038a3.933 3.933 0 1 1-4.2 3.641 3.932 3.932 0 0 1 4.2-3.641Zm0 27.836a3.933 3.933 0 1 1 3.641-4.2 3.933 3.933 0 0 1-3.641 4.2Z"
    />
  </svg>`;
};
